import get from 'lodash/get';
import * as types from '../actionTypes/AppointmentActionTypes';

const getStoreMap = (state, storeId) =>
    storeId ? get(state, `byStoreID.${storeId}`) : get(state, 'allStores');

const initialState = {
    byStoreID: {},
    allStores: {},
};

const updateNestedState = (state, id, newObject) => {
    const newState = { ...getStoreMap(state, id), ...newObject };
    return id
        ? {
              byStoreID: {
                  ...state.byStoreID,
                  ...{ [id]: newState },
              },
          }
        : {
              allStores: {
                  ...newState,
              },
          };
};
function AppointmentReducer(state = initialState, action = {}) {
    switch (action.type) {
        case types.GET_APPOINTMENT_LINK: {
            const isLoading = true;
            const error = {};
            const newState = updateNestedState(state, get(action, 'payload.stores'), {
                isLoading,
                error,
            });
            return { ...state, ...newState };
        }
        case types.GET_APPOINTMENT_LINK_SUCCESS:
        case types.GET_APPOINTMENT_LINK_ERROR: {
            const isLoading = false;
            const newState = updateNestedState(state, action.storeId, {
                isLoading,
                ...action.payload,
            });
            return { ...state, ...newState };
        }
        default:
            return state;
    }
}

AppointmentReducer.reducerName = 'appointmentDetails';

export default AppointmentReducer;
